(function () {
  $('.nav-rail').clickMenu({
    menutype: 'accordion',
    expanders: true,
    isAutoClose: false,
  });
  if ($('.nav-rail').length) {
    $('.nav-rail > ul > li.active > div .has-sub').trigger('click', {
      skipFocus: true,
    });
  }
})();
